import React from 'react'
import PropTypes from 'prop-types'
import Styles from './index.scss'

import InvoiceItem from './Item'

const TabInvoice = (props) => {
  const totalInvoice = props.projectInvoices.length
  if (props.projectInvoices.length > 0) {
    return (
      <div>
        {
          props.projectInvoices.map((invoice, index) => (
            <InvoiceItem
              invoice={invoice}
              key={invoice.id}
              index={index}
              generateTaxInvoice={props.generateTaxInvoice}
              generatePaymentSlip={props.generatePaymentSlip}
              selectedCreators={props.selectedCreators}
              upload={props.upload}
              totalInvoice={totalInvoice}
            />
          ))
        }
      </div>
    )
  }
  return (
    <section className={`section-tab ${Styles['section-invoice']}`}>
      <div className={`${Styles['container-empty']}`}>
        <h4 className={`${Styles['title-label']}`}>Invoice List</h4>
        <div className={`${Styles['empty-message-container']}`}>
          <span className={`${Styles['empty-message']}`}>
            There is no invoices yet
          </span>
        </div>
      </div>
    </section>
  )
}

TabInvoice.propTypes = {
  projectInvoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  upload: PropTypes.shape({}).isRequired,
}

export default TabInvoice
